import helper from '../helper'
import ls from 'local-storage'
import EventEmitter from 'events'

class Nexus extends EventEmitter {
  init ({axios}) {
    this.axios = axios
  }

  getTokenPreferences () {
    let self = this

    return new Promise(function (resolve, reject) {
      self.axios.get(helper.url('api', '/account/token/preferences'))
        .then(result => {
          resolve(result.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  authenticate (email, password) {
    let self = this

    console.log('[ NEXUS ] Try to authenticate ' + email + ' ...')

    return new Promise(function (resolve, reject) {
      self.axios.post(helper.url('api', '/account/token/generate'), {email, password})
        .then(result => {
          self.setToken(result.data.token)
          self.emit('connected')
          resolve(result.data.token)
        })
        .catch(error => {
          self.emit('disconnected')
          reject(error)
        })
    })
  }

  refreshToken () {
    let self = this

    console.log('[ NEXUS ] Try to refresh token ' + this.getToken() + ' ...')

    return new Promise(function (resolve, reject) {
      self.axios.post(helper.url('api', '/account/token/regenerate'), {token: self.getToken()})
        .then(result => {
          self.setToken(result.data.token)
          resolve(result.data.token)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  hasToken () {
    return this.getToken() !== null
  }

  getToken () {
    return ls.get('token')
  }

  setToken (token) {
    ls.set('token', token)
    this.emit('changed-token', {token})

    console.log('[ NEXUS ] Updated new token : ' + this.getToken() + '.')
  }

  forgetToken () {
    ls.remove('token')
    this.emit('changed-token', {token: null})

    console.log('[ NEXUS ] Token forgotten.')
  }
}

export let nexus = new Nexus()



//////////////////
// WEBPACK FOOTER
// ./libs/@db2b/nexus-js-v1/transport/nexus.js
// module id = 221
// module chunks = 1